module.exports = __webpack_public_path__ + "img/logo-transparent.d530962a.png";